export default {
  setRoute (state: {[key:string]: string}, value: string) {
    state.route = value
  },
  setErrorFlag (state:any, flag: number) {
    state.errorFlag = flag
  }
}
